import axios from 'axios'
import { getToken } from './auth'

const Api = axios.create({
  baseURL: 'https://gigliohomologacao.up.railway.app',
  //baseURL: 'http://localhost:3001',
  //baseURL: process.env.REACT_APP_BASE_URL, //'http://26.10.143.9:3001/',
  timeout: 99999999,
})

Api.interceptors.request.use(async (config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
    let windowId = sessionStorage.getItem('windowId');
  
  if (!windowId) {
    windowId = 'aba_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('windowId', windowId);
  }
  
  config.headers['X-Window-Id'] = windowId;
  return config
})

export default Api
